import { Upload, Modal } from 'antd';
import React, { useEffect, useState, useRef } from 'react';
import { Navigate, Outlet, useNavigate, useLocation } from 'react-router-dom'
import { ExclamationCircleFilled, PlusOutlined } from '@ant-design/icons';
import axios from 'axios';
import PreviewImgModal from './components/PreviewImgModal';
const { confirm } = Modal;

const UploadImg = ({
    api = "/media/api/file/upload",
    defaultValue = [],
    onImagesChange = () => { }
}) => {
    const [fileList, setFileList] = useState([]);
    const [img, setImg] = useState('');
    const [modal_img, set_modal_img] = useState(false);

    const handleUpload = (e) => {
        e = e.file;
        let form_data = new FormData();
        form_data.append('inputFile', e);
        axios
            .post(`${api}`, form_data,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
            .then((response) => {
                let file_id = parseInt(response.data.file_id);
                const dataurl = URL.createObjectURL(e);
                setFileList(prev => {
                    let temp = [
                        ...prev,
                        {
                            uid: file_id,
                            url: dataurl
                        }
                    ]
                    let data = temp.map((value) => {
                        return {
                            file_id: value?.uid,
                            file_url: value?.url
                        }
                    })
                    onImagesChange(data)
                    return temp
                }
                );

            })
    }
    const showConfirm = (e) => {
        confirm({
            title: '確認要刪除此張圖片嗎？',
            icon: <ExclamationCircleFilled />,
            okText: '確定',
            okType: 'primary',
            cancelText: '取消',
            onOk() {
                remove(e);
            },
        });
    };
    const handlePreview = (e) => {
        setImg(e.url);
        set_modal_img(true);
    }
    const remove = (e) => {

        setFileList((prev) => {
            let data = prev.filter(filter_item => filter_item.uid !== e.uid).map((value) => {
                return {
                    file_id: value?.uid,
                    file_url: value?.url
                }
            })
            onImagesChange(data)
            return prev.filter(filter_item => filter_item.uid !== e.uid)
        }
        );
    }
    const compareToChange = () => {
        if (defaultValue) {
            let compareFilelist = fileList.map((value) => {
                return value?.uid
            })
            let defaultValuefileList = defaultValue.map((value) => {
                return value?.file_id
            })
            compareFilelist.sort();
            defaultValuefileList.sort();
            if (JSON.stringify(compareFilelist) !== JSON.stringify(defaultValuefileList)) {
                let filelistTemp = defaultValue.map((value) => {
                    return {
                        uid: value?.file_id,
                        url: value?.file_url,
                    }
                })
                setFileList(pre => {
                    return defaultValue.map((value) => {
                        return {
                            uid: value?.file_id,
                            url: value?.file_url,
                        }
                    })
                })

            }
        }
    }
    const get_picture = (temp) => {
        temp.forEach(element => {
            if (element?.uid) {
                axios
                    .get(api, {
                        responseType: 'blob',
                        params: {
                            "file_id": element?.uid
                        }
                    })
                    .then((response) => {
                        var blob_ = new Blob([response.data], {
                            type: "image/jpg",// this is the only MIME for SVG

                        });
                        const dataurl = URL.createObjectURL(blob_);
                        setFileList(
                            (pre) => {
                                return (
                                    pre.map((value, index) => {
                                        if (element?.uid === value?.uid) {
                                                return (
                                                    {
                                                        ...value,
                                                        url: dataurl
                                                    }
                                                )
                                        } else {
                                            return (
                                                {
                                                    ...value,
                                                }
                                            )
                                        }
                                    })
                                )
                            }
                        )
                    })
            }


        })

    }

    useEffect(() => {
        let filelistTemp = defaultValue.map((value) => {
            return {
                uid: value?.file_id,
                url: value?.file_url,
            }
        })
        get_picture(filelistTemp)
        compareToChange()
    }, [defaultValue])

    // useEffect(() => {

    // }, [fileList])
    return (<>
        <PreviewImgModal
            modal_img={modal_img}
            set_modal_img={set_modal_img}
            img={img}
        ></PreviewImgModal>
        <Upload
            accept="image/png,image/jpeg"
            customRequest={handleUpload}
            listType="picture-card"
            fileList={fileList}
            onPreview={handlePreview}
            onRemove={e => showConfirm(e)}
            // onChange={handleUpload} 
            beforeUpload={false}
            multiple
        >
            <div>
                <PlusOutlined />
                <div
                    style={{
                        marginTop: 8,
                    }}
                >
                    上傳圖片
                </div>
            </div>
        </Upload>
    </>

    )
}
export default UploadImg
